const MANAGEMENT_LISTS_EXPORT_EMPLOYEES = 'Click Export Employees';
const MANAGEMENT_LISTS_EXPORT_PROJECTS = 'Click Export Projects';
const MANAGEMENT_LISTS_EXPORT_COST_CODES = 'Click Export Cost Codes';
const MANAGEMENT_LISTS_EXPORT_EQUIPMENT = 'Click Export Equipment';
const MANAGEMENT_LISTS_PRINT_EMPLOYEES = 'Management Lists Employees print icon click';
const MANAGEMENT_LISTS_PRINT_PROJECTS = 'Management Lists Projects print icon click';
const MANAGEMENT_LISTS_PRINT_COST_CODES = 'Management Lists Cost Codes print icon click';
const MANAGEMENT_LISTS_PRINT_EQUIPMENT = 'Management Lists Equipment print icon click';

const managementListsAnalyticsConstants = {
  MANAGEMENT_LISTS_EXPORT_EMPLOYEES,
  MANAGEMENT_LISTS_EXPORT_PROJECTS,
  MANAGEMENT_LISTS_EXPORT_COST_CODES,
  MANAGEMENT_LISTS_EXPORT_EQUIPMENT,
  MANAGEMENT_LISTS_PRINT_EMPLOYEES,
  MANAGEMENT_LISTS_PRINT_PROJECTS,
  MANAGEMENT_LISTS_PRINT_COST_CODES,
  MANAGEMENT_LISTS_PRINT_EQUIPMENT,
};

export default managementListsAnalyticsConstants;
